export default {
  nav: {
    home: 'Ana Sayfa',
    about: 'Hakkımızda',
    menu: 'Menü',
    gallery: 'Galeri',
    location: 'Konum',
    contact: 'İletişim'
  },
  hero: {
    badge: 'TÜRKİYE\'NİN İLK KÖZDE KAHVECİSİ',
    title: 'Mola Közde Kahveci',
    subtitle: 'Geleneksel Türk Kahvesi Kültürünü Közde Pişirme Sanatıyla Buluşturan',
    description: 'Kadıköy\'ün kalbinde, benzersiz közde kahve deneyimi',
    exploreMenu: 'Menümüzü Keşfedin',
    visitUs: 'Bizi Ziyaret Edin',
    feature1Title: 'Közde Pişirme',
    feature1Desc: 'Geleneksel közde pişirme yöntemiyle eşsiz lezzet',
    feature2Title: 'Öncü Konsept',
    feature2Desc: 'Türkiye\'nin ilk ve tek közde kahve konsepti',
    feature3Title: 'Kadıköy\'de',
    feature3Desc: 'Moda Caddesi\'nde sizi bekliyoruz'
  },
  about: {
    badge: 'Hikayemiz',
    title: 'Türkiye\'nin İlk',
    titleBold: 'Közde Kahvecisi',
    subtitle: '1988\'den beri geleneksel Türk kahvesi kültürünü modern bir dokunuşla harmanlayan benzersiz bir deneyim',
    experience: 'Yıllık Tecrübe',
    sectionTitle: 'Benzersiz Bir',
    sectionTitleBold: 'Kahve Deneyimi',
    paragraph1: 'Mola Közde Kahveci, 1988 yılında Eminönü\'nde başlayan bir tutku ile kuruldu. Türk kahvesi severlere unutulmaz bir deneyim sunma hedefiyle yola çıkan hikayemiz, 2000 yılında Kadıköy\'e taşınarak yeni bir sayfa açtı. Türkiye\'nin ilk ve tek közde kahve konsepti ile geleneksel lezzetleri modern bir atmosferde buluşturuyoruz.',
    paragraph2: 'Közde pişirme yöntemi, kahvenin aromasını ve tadını en üst seviyeye çıkarır. Her fincan kahve, ustalarımız tarafından özenle hazırlanır ve size özel olarak sunulur. Bu benzersiz pişirme tekniği sayesinde kahvenin gerçek lezzetini keşfedeceksiniz.',
    paragraph3: 'Sadece kahve değil, aynı zamanda sıcak bir atmosfer ve samimi bir ortam sunuyoruz. Mola Közde Kahveci, arkadaşlarınızla buluşabileceğiniz, kitap okuyabileceğiniz ve kendinize zaman ayırabileceğiniz bir mola noktası.',
    feature1Title: 'Özel Tarifler',
    feature1Desc: 'Geleneksel yöntemlerle hazırlanan özel kahve tarifleri',
    feature2Title: 'Kaliteli Malzeme',
    feature2Desc: 'En kaliteli kahve çekirdekleri ve malzemeler',
    feature3Title: 'Usta Kahveciler',
    feature3Desc: 'Deneyimli ve tutkulu kahve ustaları',
    feature4Title: 'Samimi Ortam',
    feature4Desc: 'Sıcak ve davetkar bir atmosfer',
    charcoalTitle: 'Közde Pişirme Nedir?',
    charcoalDesc1: 'Közde pişirme, Türk kahvesinin geleneksel ateş üzerinde, közün sıcaklığıyla yavaş yavaş pişirilmesi yöntemidir. Bu teknik, kahvenin aromasını ve tadını en üst seviyeye çıkarır. Közün eşit ısısı sayesinde kahve köpüğü mükemmel bir şekilde oluşur ve kahvenin gerçek lezzeti ortaya çıkar.',
    charcoalDesc2: 'Bu özel pişirme yöntemi, sabır ve ustalık gerektirir. Her fincan kahve, ustalarımız tarafından özenle hazırlanır ve size en taze haliyle sunulur.'
  },
  menu: {
    badge: 'Lezzetlerimiz',
    title: 'Menümüz',
    subtitle: 'Geleneksel lezzetler ve özel tariflerle hazırlanan zengin menümüz',
    coffee: 'Kahve Çeşitleri',
    tea: 'Çay Çeşitleri',
    cold: 'Soğuk İçecekler & Milkshake',
    dessert: 'Pasta Çeşitleri',
    popular: 'Popüler',
    close: 'Kapat',
    vatIncluded: 'Fiyatlara KDV dahildir'
  },
  gallery: {
    badge: 'Galeri',
    title: 'Mola\'dan Kareler',
    subtitle: 'Kahve tutkumuzun ve samimi atmosferimizin görsel hikayesi',
    followText: 'Daha fazla fotoğraf için Instagram hesabımızı takip edin',
    image1Title: 'Közde Kahve Hazırlığı',
    image1Desc: 'Geleneksel yöntemle hazırlanan kahvemiz',
    image2Title: 'Özel Sunum',
    image2Desc: 'Her detayı özenle hazırlanmış sunumlar',
    image3Title: 'Samimi Atmosfer',
    image3Desc: 'Sıcak ve davetkar ortamımız',
    image4Title: 'Kahve Molası',
    image4Desc: 'Uzaktan bakış, huzur alanı',
    image5Title: 'Usta Ellerde',
    image5Desc: 'Sektördeki büyük tecrübe',
    image6Title: 'Kaliteli Malzemeler',
    image6Desc: 'En iyi kahve çekirdekleri'
  },
  location: {
    badge: 'Konum',
    title: 'Bizi Ziyaret Edin',
    subtitle: 'Kadıköy\'ün kalbinde, Mühürdar Caddesi üzerinde sizi bekliyoruz',
    addressTitle: 'Adres',
    address: 'Caferağa, Mühürdar Cd. No:25, 34710 Kadıköy/İstanbul',
    getDirections: 'Yol Tarifi Al',
    contactTitle: 'İletişim',
    callNow: 'Hemen Ara',
    transportTitle: 'Ulaşım',
    transport1: 'Kadıköy Metro - 5 dakika yürüme mesafesinde',
    transport2: 'Otobüs duraklarına 2 dakika yürüme mesafesinde',
    transport3: 'Yakın çevrede otopark imkanı mevcut',
    openInMaps: 'Google Maps\'te Aç'
  },
  contact: {
    phone: 'Telefon',
    address: 'Adres'
  },
  footer: {
    description: 'Geleneksel Türk kahvesi kültürünü közde pişirme sanatıyla buluşturan benzersiz bir deneyim.',
    quickLinks: 'Hızlı Linkler',
    about: 'Hakkımızda',
    menu: 'Menü',
    gallery: 'Galeri',
    location: 'Konum',
    contact: 'İletişim',
    contactInfo: 'İletişim Bilgileri',
    workingHours: 'Çalışma Saatleri',
    everyday: 'Her Gün',
    open247: '7/24 Açık',
    reservation: 'Rezervasyon',
    reservationNote: 'Grup rezervasyonları için lütfen önceden arayın.',
    copyright: '© 2025 Mola Közde Kahveci. Tüm hakları saklıdır.'
  }
};